import napStyles from './../nap.json'

export default {
  color: napStyles.colors.SecondaryGreySteel
}
